export default __webpack_public_path__ + "f467c3283c3efc71574b452f1bc0dd16.png";